import React, { useState, useCallback } from 'react';
import { createShareData, copyToClipboard, generateShareLink } from '../utils/shareUtils';

export default function SharePanel({ text, onClose, onGetAudioState }) {
  const [copied, setCopied] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const audioState = onGetAudioState ? onGetAudioState() : null;
  const shareData = text ? createShareData(text, audioState) : null;

  const copyContent = useCallback(async (content) => {
    if (!content) return;
    await copyToClipboard(content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, []);

  const handleDownload = useCallback(() => {
    if (!shareData) return;
    const blob = new Blob([shareData.json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `geez-text-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }, [shareData]);

  if (!text) {
    return (
      <div className="share-panel">
        <div className="share-placeholder">Type text to enable sharing</div>
      </div>
    );
  }

  return (
    <div className="share-panel">
      <div className="share-header">
        <span className="share-title">Share</span>
        <button className="share-close" onClick={onClose}>✕</button>
      </div>

      <div className="share-preview">
        {text.length > 40 ? text.substring(0, 40) + '…' : text}
      </div>

      <div className="share-actions">
        <button className="share-btn" onClick={() => copyContent(text)}>
          📋 Copy Text
        </button>
        <button className="share-btn" onClick={() => shareData && copyContent(generateShareLink(shareData.base64))}>
          🔗 Copy Link
        </button>
        <button className="share-btn" onClick={() => shareData && copyContent(shareData.base64)}>
          🔐 Copy Base64
        </button>
        <button className="share-btn" onClick={handleDownload}>
          💾 Download JSON
        </button>
      </div>

      {copied && <div className="share-copied">✓ Copied!</div>}

      <div className="share-meta">
        <button className="meta-toggle" onClick={() => setExpanded(!expanded)}>
          {expanded ? '▼' : '▶'} Metadata {expanded ? '' : '...'}
        </button>
        {expanded && shareData && (
          <div className="meta-content">
            <div>Schema: {shareData.object.schema}</div>
            <div>Version: {shareData.object.version}</div>
            <div>Chars: {shareData.object.metadata.charCount}</div>
            <div>Words: {shareData.object.metadata.wordCount}</div>
            <div>Unique: {shareData.object.metadata.uniqueChars}</div>
            <div>Crossfade: {shareData.object.audioState?.crossfadeMode || 'automatic'}</div>
            <div className="meta-url">
              {generateShareLink(shareData.base64).substring(0, 50)}…
            </div>
          </div>
        )}
      </div>

      {shareData && (
        <div className="share-base64-preview">
          <code>{shareData.base64.substring(0, 60)}…</code>
        </div>
      )}
    </div>
  );
}